<template>
    <ul class="sidebar-links text-center">
      <li v-for="link in filteredLinks" :key="link.to">
        <router-link :to="link.to" class="link">
          {{ $t(link.label) }}
        </router-link>
      </li>
    </ul>
  </template>
  
  <script>
  export default {
    name: "SidebarLandingPageLinks",
    computed: {
      filteredLinks() {
        return this.links.filter(link => link.to !== this.$route.path);
      },
    },
    data() {
      return {
        links: [
          { to: "/login", label: "landingPage.login" },
          { to: "/register", label: "landingPage.register" },
          { to: "/policy/about", label: "landingPage.aboutUs" },
          { to: "/policy/terms", label: "landingPage.termsAndConditions" },
          { to: "/policy/privacy", label: "landingPage.privacyPolicy" },
        ],
      };
    },
  };
  </script>
  
  <style scoped>
  .sidebar-links {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  
  .sidebar-links li {
    margin: 8px 0;
  }
  
  .link {
    text-decoration: none;
    color: inherit;
  }
  
  .link:hover {
    text-decoration: underline;
  }
  </style>
  